<template>
  <div class="">
    <div @click="showQuestion = !showQuestion" class="cursor-pointer flex items-center justify-between">
      <slot name="question"></slot>
      <svg v-if="!showQuestion" class="h-3 w-3 mr-6">
        <use xlink:href="#plus"></use>
      </svg>
      <svg v-if="showQuestion" class="h-3 w-3 mr-6">
        <use xlink:href="#minus"></use>
      </svg>
    </div>

    <transition name="fade">
      <slot v-if="showQuestion" name="answer"></slot>
    </transition>
  </div>
</template>

<script>
import { EventBus } from "../lib/event-bus.js"

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    refId: {
      required: true
    }
  },

  data() {
    return {
      showQuestion: this.open
    }
  },

  watch: {
    showQuestion(newVal) {
      if (newVal) {
        EventBus.$emit('open-accordian-item', this.refId)
      } else {
        EventBus.$emit('close-accordian-item', this.refId)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/AccordianItem.vue